import { graphql, useStaticQuery } from 'gatsby'

import ReleasesList from './ReleasesList'

const LinuxReleases = () => {
  const {
    allMdx: { edges: linuxReleaseEdges },
  } = useStaticQuery(graphql`
    query LinuxReleaseNotes {
      allMdx(
        sort: { fields: [frontmatter___date], order: DESC }
        filter: {
          fileAbsolutePath: { regex: "/src/release-notes/" }
          frontmatter: { platform: { eq: "Linux" } }
        }
      ) {
        edges {
          node {
            fileAbsolutePath
            frontmatter {
              title
              date: date(formatString: "LL")
              notes {
                type
                note
              }
            }
          }
        }
      }
    }
  `)

  return <ReleasesList edges={linuxReleaseEdges} />
}

export default LinuxReleases
